<div (click)="openWhatsApp()">
  <i class="fab fa-whatsapp" aria-hidden="true"></i>
  {{'button.open-whatsapp' | translate}}
</div>